export default {"src":"/_next/static/media/new-ethos-logo-white.09bc8237.svg","height":18,"width":89,"blurWidth":0,"blurHeight":0};